import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ behavior = 'instant' }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    try {
      // Modern browsers
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
      });
    } catch (error) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
    
    // Also reset any scrollable containers to top
    const scrollableElements = document.querySelectorAll('[data-scroll-container]');
    scrollableElements.forEach(element => {
      element.scrollTop = 0;
    });
  }, [pathname, behavior]);

  return null;
};

export default ScrollToTop;
